import * as React from 'react';
export const terminalSvg = React.forwardRef(function terminalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 9h1.5v7H8V9Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 8.5h8v6a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 14.5v-6ZM5.5 10v4.5h5V10h-5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.25 9.25A.75.75 0 0 1 4 8.5h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 1.5h8A1.5 1.5 0 0 1 13.5 3v7a1.5 1.5 0 0 1-1.5 1.5V13a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3v-1.5A1.5 1.5 0 0 1 2.5 10V3A1.5 1.5 0 0 1 4 1.5Z',
    }),
  );
});
terminalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var terminal = {
  category: 'icon',
  colorable: true,
  name: 'terminal',
  svg: terminalSvg,
};
